<template>
  <div>
    <v-row>
      <v-col cols="12" class="py-1">
        <v-toolbar color="transparent" flat>
          <v-toolbar-title class="headline-header text-h6 px-0">{{ title }}
          </v-toolbar-title>
          <v-spacer/>
          <v-btn depressed rounded color="teal" dark @click="toggleForm">
            <v-icon>mdi-plus</v-icon> Adicionar
          </v-btn>
        </v-toolbar>
      </v-col>
    </v-row>
    <v-divider class="pb-2 divider-header"/>
    <v-table-view-list/>
    <v-modal-form/>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import VTableViewList from './Table.vue';
import VModalForm from './ModalForm.vue';

export default {
  name: 'ModeloList',
  components: {
    VTableViewList,
    VModalForm,
  },
  metaInfo: {
    title: 'Modelo',
    titleTemplate: `%s | ${process.env.VUE_APP_TITLE}`,
  },
  data: () => ({
    title: 'Modelo',
  }),
  created() {
  },
  methods: {
    ...mapActions('modelo', ['toggleForm']),
  },
};
</script>
